import { NSBanner, NSButtonBlue, NSColumn, NSRow, NSSection, NSSpace, NSSpaceSizeType } from "namirasoft-site-react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { PaymentProps } from "../PaymentProps";
import { PaymentLayout } from "../PaymentLayout";
import Styles from './SubscriptionCancellationResultPage.module.css';

export interface SubscriptionCancellationResultPageProps extends NSARouterMakerResult, PaymentProps
{ }

function SubscriptionCancellationResultPage(props: SubscriptionCancellationResultPageProps)
{
	return (
		<PaymentLayout {...props}
			action={{
				title: "Cancelation Confirmation",
				description: "Review important information about the consequences of canceling your subscription.",
				menus: {}
			}}
		>
			<NSSection>
				<NSColumn>
					<NSRow>
						<NSBanner
							imageLeft={{
								src: "https://static.namirasoft.com/image/concept/bot/upset.png",
								alt: "upset bot"
							}}
							imageRight={null}
							title={{
								text: "We're sorry to see you go!",
								style: {
									color: "rgba(255, 63, 63, 1)",
									fontWeight: "bold"
								}
							}}
						/>
					</NSRow>
				</NSColumn>
				<NSSpace size={NSSpaceSizeType.SMALL} />
				<div className={Styles.nsp_subscription_cancellation_result_description}>
					<h4>Thank you for being a valued customer.</h4>
					<p>We hope you enjoyed using our service. Your access has stopped or will continue until the end of your subscription period, depending on your plan.</p>
					<h4>If you have any feedback or need assistance, please don't hesitate to contact us.</h4>
					<NSSpace size={NSSpaceSizeType.NORMAL} />
					<NSButtonBlue
						title="Contact Us"
						onClick={{
							action: () => { window.open("https://support.namirasoft.com/", "_blank") },
							showLoading: false
						}}
					/>
				</div>
			</NSSection>
		</ PaymentLayout>

	);
}

export default SubscriptionCancellationResultPage;